import styled from 'styled-components';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Container = styled.div `
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 8px 0;
  margin: -8px 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }

  ${tabNavigationStyle};
`;
export const Slide = styled.li `
  display: flex;
  flex-shrink: 0;
  ${tabNavigationStyle};
  padding: 0 8px;

  ${({ slideWidth }) => (slideWidth ? `width: ${slideWidth}px;` : ``)}

  &:before,
  &:after {
    display: none;
  }

  > * {
    flex-grow: 1;
  }

  &:first-of-type {
    padding-left: 0;
  }

  &:last-of-type {
    padding-right: 0;
  }
`;
export const SlideLink = styled.a `
  display: block;
  text-decoration: none;
`;
//# sourceMappingURL=style.js.map